import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'bushDark',
      d: 'M2,-1h1v0.5h-1zM2.5,-0.5h0.5v0.5h-0.5zM-3,0h6v0.5h-6zM-1,0.5h1.5v0.5h-1.5z',
    },
    {
      paint: 'moss',
      d: 'M-2,-1.5h3.5v0.5h-3.5zM-3,-1h0.5v0.5h-0.5zM-1,-1h1.5v0.5h-1.5zM1,-1h1v0.5h-1zM-3,-0.5h5.5v0.5h-5.5z',
    },
    { paint: 'leafLight', d: 'M-2.5,-1h1.5v0.5h-1.5zM0.5,-1h0.5v0.5h-0.5z' },
  ],
  pixels: 46,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
